
(function() {
  var result = { translations: { "uk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A\u0443\u043D\u0434", "minutes": "{{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "hours": "{{ hours }} \u0433\u043E\u0434\u0438\u043D", "hoursAndMinutes": "{{ hours }} \u0433\u043E\u0434\u0438\u043D {{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0456\u0432", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u0445\u0432", "hours": "{{ hours }}\u0433\u043E\u0434", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0433\u043E\u0434 {{ minutes }}\u0445\u0432" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0434. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "uk": "static-7.1116"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1116",
    "ar-eg": "static-7.1116",
    "bg": "static-7.1116",
    "bn": "static-7.1116",
    "ca-es": "static-7.1116",
    "cs": "static-7.1116",
    "da": "static-7.1116",
    "de": "static-7.1116",
    "el": "static-7.1116",
    "en-gb": "static-7.1116",
    "en": "static-7.1116",
    "es-mx": "static-7.1116",
    "es": "static-7.1116",
    "et": "static-7.1116",
    "fi": "static-7.1116",
    "fr-ca": "static-7.1116",
    "fr": "static-7.1116",
    "he-il": "static-7.1116",
    "hi": "static-7.1116",
    "hr": "static-7.1116",
    "hu": "static-7.1116",
    "id": "static-7.1116",
    "it": "static-7.1116",
    "ja": "static-7.1116",
    "ko": "static-7.1116",
    "lt": "static-7.1116",
    "ms": "static-7.1116",
    "nl": "static-7.1116",
    "no": "static-7.1116",
    "pl": "static-7.1116",
    "pt-br": "static-7.1116",
    "pt-pt": "static-7.1116",
    "ro": "static-7.1116",
    "ru": "static-7.1116",
    "sk": "static-7.1116",
    "sl": "static-7.1116",
    "sv": "static-7.1116",
    "th": "static-7.1116",
    "tl": "static-7.1116",
    "tr": "static-7.1116",
    "uk": "static-7.1116",
    "vi": "static-7.1116",
    "x-pseudo": "static-7.1116",
    "zh-cn": "static-7.1116",
    "zh-hk": "static-7.1116",
    "zh-tw": "static-7.1116"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:uk', {version: 'static-7.1116'}); }
})();


